import { FileAceClaimAction, ErrorStep, PreventSubmit } from './types';
import {
  InsertAceClaimDto,
  InsertAceClaimItemDto,
  SubmitAceClaimDto,
  DeleteAceClaimItemDto,
} from '@/core-types/ace-claim';
import { AceClaim } from '@/core-types/claim';
import { DeleteDamageDto, InsertDamageDto } from '@/core-types/damage';
import { InsertWarrantyItemDto } from '@/core-types/warranty-item';

export const insertAceClaim = (payload: InsertAceClaimDto) =>
  ({
    type: FileAceClaimAction.INSERT_CLAIM,
    payload,
  } as const);

export const insertAceClaimItem = (payload: InsertAceClaimItemDto[]) =>
  ({
    type: FileAceClaimAction.INSERT_CLAIM_ITEM,
    payload,
  } as const);

export const updateActiveAceClaim = (payload: Partial<AceClaim>) =>
  ({
    type: FileAceClaimAction.UPDATE_ACTIVE_CLAIM,
    payload,
  } as const);

export const setPreventSubmitAceClaim = (payload: PreventSubmit) =>
  ({
    type: FileAceClaimAction.SET_PREVENT_SUBMIT_CLAIM,
    payload,
  } as const);

export const removePreventSubmitAceClaim = (payload: PreventSubmit) =>
  ({
    type: FileAceClaimAction.REMOVE_PREVENT_SUBMIT_CLAIM,
    payload,
  } as const);

export const setErrorSteps = (payload: ErrorStep) =>
  ({
    type: FileAceClaimAction.SET_ERROR_STEPS,
    payload,
  } as const);

export const removeErrorSteps = (payload: ErrorStep) =>
  ({
    type: FileAceClaimAction.REMOVE_ERROR_STEPS,
    payload,
  } as const);

export const clearErrorSteps = (payload: ErrorStep) =>
  ({
    type: FileAceClaimAction.CLEAR_ERROR_STEPS,
    payload,
  } as const);

export const removeActiveAceClaim = () =>
  ({
    type: FileAceClaimAction.REMOVE_ACTIVE_CALIM,
  } as const);

export const insertAceClaimItemDamage = (payload: InsertDamageDto[]) =>
  ({
    type: FileAceClaimAction.INSERT_CLAIM_ITEM_DAMAGE,
    payload,
  } as const);

export const submitClaim = (payload: SubmitAceClaimDto) =>
  ({
    type: FileAceClaimAction.SUBMIT_CLAIM,
    payload,
  } as const);

export const deleteAceDamage = (payload: DeleteDamageDto) =>
  ({
    type: FileAceClaimAction.DELETE_DAMAGE,
    payload,
  } as const);

export const insertWarrantyItem = (payload: InsertWarrantyItemDto) =>
  ({
    type: FileAceClaimAction.INSERT_WARRANTY_ITEM,
    payload,
  } as const);

export const deleteClaimItem = (payload: DeleteAceClaimItemDto) =>
  ({
    type: FileAceClaimAction.DELETE_CLAIM_ITEM,
    payload,
  } as const);

export const submitAceClaim = (payload: any) =>
  ({
    type: FileAceClaimAction.SUBMIT_ACE_CLAIM,
    payload,
  } as const);
